import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Grid } from "@mui/material";
import { CheckBox, Dropdown, UploadFile } from "@egovernments/digit-ui-react-components";
import axios from "axios";

import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import FormattedDate from "../../TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

const useStyles = makeStyles((theme) => ({
  p: {
    fontSize: "14px",
    overflow: "hidden",
    whitespce: "nowrap",
  },
}));
const ChatBoardReply = ({ formData, messageId }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const Modal = useModal();
  const { chatBoardDataRemarks, handleGetRemarkssValues, chatBoardHistoryData, handleGetHistoryRemarkssValues } = useContext(ScrutinyRemarksContext);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [chatData, setChatData] = useState([]);
  //const  [roleSet, setRoleSet] = useState([]);
  //const RoleOfUser = assignerToChatboard?.data?.processInstance?.assigner?.roles?.name;
  //const NameOfUser = assignerToChatboard?.data?.processInstance?.assigner?.roles?.code;
  //const typeOfUser = assignerToChatboard?.data?.processInstance?.assigner?.type;
  const userData = Digit.UserService.getUser() || {};
  const userInfo = userData?.info || {};
  const authToken = userData?.access_token || null;
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  //const assignerRolesArray = assignerToChatboard?.data?.processInstance?.assigner?.roles.filter((assigner) => assigner.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray?.[0]?.code;
  const designation = userRolesArray?.[0]?.name;
  const [developerRemarks, setDeveloperRemarks] = React.useState("");
  const [messageTo, setMessageTo] = React.useState(undefined);
  const [assignTo, setAssignTo] = React.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [error, setError] = useState(null);
  const statusChatBoard = chatBoardHistoryData?.egScrutiny?.[0]?.chatBoardStatus === "PENDING" ? "DONE" : "PENDING";
  const replyToMessageObj = chatBoardHistoryData?.egScrutiny?.find((val) => val.id == messageId);

  function selectFile(e) {
    setFile(e.target.files[0]);
  }

  const selectRole = (role, name) => {
    setAssignTo(role, name);
  };

  const handleUpdate = (event) => {
    const editorContent = event.target.innerHTML;
    setContent(editorContent);
  };

  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };

  const onMessageToChange = (e) => {
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };

  //const notificationFilteredData=chatBoardHistoryData?.egScrutiny?.filter((e)=>e.chatBoardStatus==="PENDING" && e.assignTo.useruuid===userInfo?.uuid);
  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken,
      },
      egScrutiny: {
        applicationId: formData?.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: true, //Message To
        userid: userInfo?.id || null,
        serviceId: messageId,
        documentId: uploadedFile, //document attachment
        bussinessServiceName: formData?.businessService,
        designation: designation,
        name: userInfo?.type || null,
        employeeName: userInfo?.name || null,
        role: filterDataRole,
        applicationStatus: formData?.status,
        assignTo: assignTo || null,
        chatBoardStatus: "PENDING",
        chatBoardReply: {},
        previousStatus: replyToMessageObj?.chatBoardStatus,
        previousUserId: replyToMessageObj?.userid,
        previousEmployeeRole: replyToMessageObj?.role,
      },
    };

    try {
      const Resp = await axios.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then((response) => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }

    let redirectPath = "/digit-ui/employee";

    Modal("Application Chat Board", `Application <strong>(${formData?.applicationNo}) Chat Board</strong> Successfully!`, "success", redirectPath);
    await handleGetRemarkssValues(formData?.applicationNo), handleGetHistoryRemarkssValues(formData?.applicationNo);
  };
  const handlemodalAttachment = (e) => {
    setUploadedFileAttachment("AttachmentOPen");
  };
  const [post, setPost] = useState({
    // title: '',
    content: "",
    hearingDate: "",
    // categoryId: ''
  });

  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);

  useEffect(() => {
    const fetchRemarks = async () => {
      if (!formData?.applicationNo) return;

      try {
        await handleGetRemarkssValues(formData?.applicationNo);
        await handleGetHistoryRemarkssValues(formData?.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };

    fetchRemarks();
  }, [formData?.applicationNo]);

  //make it dynamic later!Important
  const assignerChatbaord = [
    {
      code: replyToMessageObj?.role,
      name: replyToMessageObj?.employeeName,
    },
  ];

  return (
    <div style={{ margin: "20px" }}>
      <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <h2
          style={{ background: "linear-gradient(to right, #1E73BE, #E3F2FD)", padding: "10px", color: "#fff", fontWeight: "bold", textAlign: "left" }}
        >
          Application Details
        </h2>
        <Grid container spacing={1}>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>File Number:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.applicationNo}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px" }} item xs={6} md={3}>
            <strong>Submitted On:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {ConvertEpochToDate(formData?.auditDetails?.createdTime)}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>Name of Owner/Applicant:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.landInfo?.owners?.[0]?.name}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px" }} item xs={6} md={3}>
            <strong>Name of Architect:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.professionaldetails?.name}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingLeft: "20px", paddingBottom: "3px" }} item xs={6} md={3}>
            <strong>Case Type:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px", paddingBottom: "3px" }} item xs={6} md={3}>
            {formData?.natureOfConstruction}
          </Grid>
          <Grid style={{ backgroundColor: "#E6EFF8", fontSize: "13px", paddingBottom: "3px" }} item xs={6} md={3}>
            <strong>Project Type:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px", paddingBottom: "3px" }} item xs={6} md={3}>
            {formData?.applicationType}
          </Grid>
        </Grid>
      </Card>
      <Card style={{ marginTop: "1rem" }}>
        <Grid container spacing={1}>
          <Grid style={{ backgroundColor: "#E6EFF8", paddingLeft: "20px", paddingTop: "1rem" }} item xs={6} md={3}>
            <strong>Message To</strong>
          </Grid>
          {/* <Grid style={{backgroundColor:'white'}} item xs={6} md={6}> */}
          <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
            <CheckBox
              className="form-field"
              label={`Applicant`}
              onChange={onMessageToChange}
              checked={applicantChecked}
              style={{ marginLeft: "25px", paddingTop: "3px", fontSize: "14px" }}
            />
          </Grid>
          <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
            <CheckBox
              className="form-field"
              label={`Department`}
              onChange={onMessageToChange}
              checked={developerChecked}
              style={{ marginLeft: "25px", paddingTop: "5px", fontSize: "14px" }}
            />
          </Grid>
        </Grid>
      </Card>
      {developerChecked === true && userInfo?.type !== "CITIZEN" && (
        <Card style={{ marginTop: "1rem", overflow: "visible" }}>
          <Grid container spacing={1}>
            <Grid style={{ backgroundColor: "#E6EFF8", paddingLeft: "20px", paddingTop: "1rem" }} item xs={6} md={3}>
              <strong>Assign To</strong>
            </Grid>
            {/* <Grid style={{backgroundColor:'white'}} item xs={6} md={6}> */}
            <Grid style={{ fontSize: "14px", marginTop: "8px", marginBottom: "-8px" }} item xs={6} md={3}>
              <Dropdown
                option={assignerChatbaord}
                optionKey="name"
                optionValue="code"
                select={selectRole}
                placeholder={"Select Role"}
                style={{ marginLeft: "25px", paddingTop: "5px", fontSize: "14px", overflow: "visible" }}
              />
            </Grid>
          </Grid>
        </Card>
      )}
      <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>

        {uploadedFileAttachment === "AttachmentOPen" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn="span 3"> Document /Certificate</Box>
            <Box gridColumn="span 9">
              <UploadFile
                id={"workflow-doc"}
                onUpload={selectFile}
                onDelete={() => {
                  setUploadedFile(null);
                }}
                message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                accept="image/*, .pdf, .png, .jpeg, .jpg"
                iserror={error}
              />
            </Box>
          </Box>
        )}

        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: 20, color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalsubmit}
        >
          Send
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "10px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={closeEditor}
        >
          Cancel
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "70px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalAttachment}
        >
          Attachment
        </Button>
      </Card>

      {/* {formData && chatBoardHistoryData &&(
          <Card style={{marginTop:'1rem',boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",backgroundColor:'#E6EFF8'}}>
                  <h2 style={{ background: "linear-gradient(to right, #1E73BE, #E3F2FD)", padding: "10px", color: "#fff", fontWeight: "bold", textAlign: "left" }}>History Of Web Message</h2>
                     {chatBoardHistoryData?.egScrutiny?.map((item, index) => (
                                <div style={{width:'100%'}}>
                                 <Card style={{float:item?.userid == userInfo?.id?'right':'left',width:'50%',boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",marginRight:"5px",padding:"5px"}}>
                              <p>AssignTo:{item?.assignTo?.name},{item?.assignTo?.code}</p> 
                                 <p>Message:{<p style={{display:'inline'}} dangerouslySetInnerHTML={{__html: item?.comment}}/>}</p>    
                                  <p>File:{item?.applicationId}</p>   
                                      <p>Chat Board :{item?.chatBoardStatus}</p>
                                      <p>Created By:{item?.employeeName},({item?.designation})</p>
                                     <p>Recipients</p>
                                      <p>Date:{ConvertEpochToDate(item?.createdOn)}</p>
                                      <p>Attachments:{item?.documentId}</p>
                                      
                                 </Card>
                                 
                                 <br></br><br></br>
                                </div>
                                )
                               )};
            </Card>

) } */}
      {formData && chatBoardHistoryData?.egScrutiny && (
        <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
          <h2
            style={{
              background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
              padding: "10px",
              color: "#fff",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            History Of Web Message
          </h2>
          {/* <CardHeader title="History Of Web Message" titleTypographyProps={{fontSize:'16px',fontWeight:'600',color:'#FFFFFF'}} style={{backgroundColor:'#1F4A7C',padding:'10px'}}></CardHeader> */}
          <section className="remarks-table">
            <table>
              <thead>
                <tr>
                  <th style={{ fontSize: "12px" }}>Sr. No</th>
                  <th style={{ fontSize: "12px" }}>AssignTo</th>
                  <th style={{ fontSize: "12px" }}>Message To</th>
                  <th style={{ fontSize: "12px" }}>Message</th>
                  <th style={{ fontSize: "12px" }}>File Number</th>
                  <th style={{ fontSize: "12px" }}>Created By</th>
                  {/* <th style={{fontSize:'12px'}}>Recipients</th> */}
                  <th style={{ fontSize: "12px" }}>Date</th>
                  <th style={{ fontSize: "12px" }}>Attachments</th>
                </tr>
              </thead>
              <tbody>
                {chatBoardHistoryData?.egScrutiny?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ fontSize: "12px" }}>{index + 1}</td>
                    <td style={{ fontSize: "12px" }}>
                      {item?.assignTo?.name || item?.fieldIdL},{item?.assignTo?.code}
                    </td>
                    <td style={{ fontSize: "12px" }}> {item?.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item?.fieldIdL}`}</td>
                    <td style={{ fontSize: "12px" }}>{item?.fieldIdL}</td>
                    <td style={{ fontSize: "12px" }}>{<SafeHtml html={item?.comment} />}</td>
                    <td style={{ fontSize: "12px" }}>{item?.applicationId}</td>
                    <td style={{ fontSize: "12px" }}>
                      {item?.employeeName},({item?.designation})
                    </td>
                    {/* <td style={{fontSize:'12px'}}></td> */}
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      <FormattedDate timestamp={item?.createdOn} />
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      <a target="_" href={item?.documentUrl} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                        <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </Card>
      )}
      {/* {formData && chatBoardDataRemarks?.egScrutiny &&(
 <ChatBoardHistory formData={formData} chatBoardDataRemarks={chatBoardDataRemarks}/>
)} */}
    </div>
  );
};

export default ChatBoardReply;
